
<table class="table table-borderless table-striped table-hover">
  <thead>
    <tr>
      <th translate>MANDATE_ID</th>
      <th translate>CUSTOMER_ID</th>
      <th translate>SIGNATURE_DATE</th>
      <th translate>IBAN</th>
      <th translate>BIC</th>
      <th translate></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let mandate of data">
      <td>{{ mandate.mandateId }}</td>
      <td>{{ mandate.customerErpId }}</td>
      <td>{{ mandate.mandateSignatureDate | date: dateUtilService.dateFormat }}</td>
      <td>{{ mandate.debtorIban }}</td>
      <td>{{ mandate.debtorBic }}</td>
      <td class="text-right actions">
        <gung-button
          classes="btn-outline-primary btn-sm mr-1"
          label="{{ 'DOWNLOAD' | translate }}"
          [onClick]="downloadMandate.bind(this, mandate.id)"
        />
        <gung-button
          classes="btn-outline-primary btn-sm"
          label="{{ 'DELETE' | translate }}"
          [onClick]="delete.bind(this, mandate.id)"
        />
      </td>
    </tr>
  </tbody>
</table>
